import React, { useContext, useState } from "react";
import moment from "moment";
import classnames from "classnames";

import { NotesContext } from "../contexts/index";
import { taskTypeToLabelMap } from "../../../shared/taskTypeMap";
import AddNote from "./add-note";

const Note = (props) => {
    const { createdBy, createdOn, note, noteType, taskType, isActive } = props.note;
    let noteHtml = "";

    if (noteType === "File") {
        function convertToUrl(text) {
            var urlRegex =
                /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gi; // eslint-disable-line

            return text.replace(urlRegex, function (url) {
                if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
                    return '<a target="_blank" rel="noopener noreferrer external" href="' + url + '">' + url + "</a>";
                } else {
                    return '<a target="_blank" rel="noopener noreferrer external" href="//' + url + '">' + url + "</a>";
                }
            });
        }
        noteHtml = convertToUrl(note);
    }

    const classVariations = {
        [`-${noteType.toLowerCase()}`]: !!noteType,
    };
    const noteCategory = taskType ? taskTypeToLabelMap[taskType] : noteType;
    const byLine =
        noteType !== "Client" ? (
            <div>
                {moment(createdOn).format("MM/DD/YY")} | {noteCategory}
                <br />
                Added by {createdBy}
            </div>
        ) : taskType ? (
            <div>{taskTypeToLabelMap[taskType]}</div>
        ) : null;

    return (
        <div className={classnames("note", { ...classVariations, "-inactive": !isActive })}>
            {noteType === "File" ? (
                <b>
                    <div dangerouslySetInnerHTML={{ __html: noteHtml }} />
                </b>
            ) : (
                <b>{note}</b>
            )}
            {byLine}
        </div>
    );
};

const NoteDisplay = (props) => {
    const { notes, addNotes } = useContext(NotesContext);
    const [taskFilter, settaskFilter] = useState(props.showAll ? [] : [props.taskType]);

    const onAdd = (value) => {
        return addNotes(value);
    };

    const notesHtml = notes.reduce((arr, note) => {
        if (!note.taskType || taskFilter.length === 0 || taskFilter.includes(note.taskType)) {
            arr.push(<Note key={`note_${note.noteId}`} note={note} />);
        }

        return arr;
    }, []);

    const toggleFilter = (e) => {
        e.preventDefault();

        settaskFilter(taskFilter.length > 0 ? [] : [props.taskType]);
    };

    const filterText = taskFilter.length > 0 ? "Show All Task Notes" : `Filter ${taskTypeToLabelMap[props.taskType]} Notes`;

    return (
        <div className={classnames("note-display", { "-max-height": props.maxHeight })}>
            <div className="notes-scroll">{notesHtml}</div>

            <div className="notes-control">
                {notes.length > 0 && props.taskType && (
                    <a href="#noteFilter" className="button -text toggle-button" onClick={toggleFilter}>
                        {filterText}
                    </a>
                )}
                {notes.length <= 0 && <h4 className="txt-center">There are no notes to display</h4>}

                {!props.disableAdd && !props.isReadOnly && <AddNote addNote={onAdd} />}
            </div>
        </div>
    );
};

export default NoteDisplay;
